import { render, staticRenderFns } from "./CustomInputRadio.vue?vue&type=template&id=0c729de6&scoped=true&"
import script from "./CustomInputRadio.vue?vue&type=script&lang=js&"
export * from "./CustomInputRadio.vue?vue&type=script&lang=js&"
import style0 from "./CustomInputRadio.vue?vue&type=style&index=0&id=0c729de6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c729de6",
  null
  
)

export default component.exports